import {
  createHighlighter,
  Highlighter,
  HighlighterGeneric,
  ThemedToken,
  LanguageRegistration,
} from "shiki";
import tmLanguageSyntax from "@/src/polar.tmLanguage.json";

const polarSyntaxHighlighterPromise: Promise<
  HighlighterGeneric<"polar", "min-light">
> = createHighlighter({
  // This `as` is necessary because of a quirk in Shiki's types: `IRawRepository`
  // has `$self` and `$base` as required properties, but these properties are
  // internally set by @shikijs/core's `textmate.mjs` file.
  langs: [tmLanguageSyntax as unknown as LanguageRegistration],
  themes: ["min-light"],
}).then(
  (highlighter: Highlighter) =>
    highlighter as unknown as HighlighterGeneric<"polar", "min-light">
);

export default async function polarSyntaxHighlighting(
  code: string
): Promise<ThemedToken[][]> {
  const highlighter = await polarSyntaxHighlighterPromise;
  const { tokens } = highlighter.codeToTokens(code, {
    lang: "polar",
    theme: "min-light",
  });
  return tokens;
}
